exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-overlay[data-v-0aea8f2d]{background:linear-gradient(180deg,#fff,rgba(33,42,74,.3))}", ""]);

// exports
